import React, { useRef } from "react";
import { triggerAnalyticsEvent } from "../../../helpers";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCamera } from "@fortawesome/free-solid-svg-icons";
import { Say, getPhrase } from "../../../languages";

type Props = {
  handleFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  classList?: string;
  visible?: boolean;
};

const SelfieButton = ({ handleFileChange, classList, visible = true }: Props) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const labelRef = useRef<HTMLLabelElement>(null);

  if (!visible) {
    return null;
  }

  const handleKeyPress = (event: React.KeyboardEvent<HTMLLabelElement>) => {
    if (event.key === "Enter") {
      inputRef.current?.click();
      reportAnalytics();
    } else if (event.key === " ") {
      event.preventDefault();
      inputRef.current?.click();
      reportAnalytics();
    }
  };

  const reportAnalytics = () => {
    const eventButtonText = labelRef.current?.innerText || "";

    triggerAnalyticsEvent("photo_upload_click", {
      chosen_photo_click: "chosen_upload_your_photo",
      eventLabel: eventButtonText
    });
  };

  return (
    <div
      className={`photo-moderation__selfie-button ${classList}`}
      aria-label={getPhrase("photo_step.upload_cta")}
      role="button">
      <label
        ref={labelRef}
        htmlFor="selfie_button"
        tabIndex={0}
        onKeyDown={handleKeyPress}
        onClick={reportAnalytics}>
        <div className="photo-moderation__selfie-button__icon">
          <FontAwesomeIcon icon={faCamera} />
        </div>
        <div className="photo-moderation__selfie-button__text">
          <Say phrase="photo_step.upload_cta" />
        </div>
      </label>
      <input
        ref={inputRef}
        id="selfie_button"
        type="file"
        accept="image/jpeg"
        onChange={handleFileChange}
        className="hidden"
      />
    </div>
  );
};

export default SelfieButton;
